import { render, staticRenderFns } from "./xingxingOptions.vue?vue&type=template&id=26a1aea8&"
import script from "./xingxingOptions.vue?vue&type=script&lang=js&"
export * from "./xingxingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a1aea8')) {
      api.createRecord('26a1aea8', component.options)
    } else {
      api.reload('26a1aea8', component.options)
    }
    module.hot.accept("./xingxingOptions.vue?vue&type=template&id=26a1aea8&", function () {
      api.rerender('26a1aea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/xingxingOptions.vue"
export default component.exports